import { InfoLayout } from "../../components/InfoLayout";

export function CapsAlignmentPage() {
  return (
    <InfoLayout
      title="CAPS alignment"
      lead="Every lesson maps to the South African CAPS FET curriculum for Grades 10–12, so what learners practise is exactly what they're examined on."
    >
      <div className="card">
        <h3>Subjects &amp; grades</h3>
        <p>
          PyDialog covers <strong>Mathematical Literacy</strong>,{" "}
          <strong>Mathematics</strong>, <strong>Accounting</strong>,{" "}
          <strong>English Home Language</strong> and{" "}
          <strong>English First Additional Language</strong> across{" "}
          <strong>Grades 10, 11 and 12</strong> — the CAPS Further Education and
          Training (FET) phase. NSC exam-prep curricula aligned to the November
          2025 papers are also available.
        </p>
      </div>

      <div className="card">
        <h3>Structured the way the curriculum is</h3>
        <p>
          Content follows the CAPS term-and-week structure, broken into lessons,
          sections, and clear learning objectives. Each objective is tagged with a
          cognitive level (from recall through to analysis and creation), so
          questions probe understanding at the depth the curriculum expects.
        </p>
      </div>

      <div className="card">
        <h3>Mathematics done accurately</h3>
        <p>
          Functions, analytical geometry, trigonometry, finance, statistics and
          Euclidean geometry are supported with figures rendered by a real maths
          engine — correct to the coordinate — rather than illustrative sketches.
        </p>
      </div>

      <div className="card">
        <h3>Examination-oriented English</h3>
        <p>
          Comprehension, language structures, literature, and the full range of
          transactional and creative writing are covered, following CAPS
          conventions and assessment expectations.
        </p>
      </div>
    </InfoLayout>
  );
}
